import Config from '@/config';
import { InfoResponse, RequestRegistration } from '@/types/api/register';
import { RequestProcessRegistration, DataResponse } from '@/types/api/registerProcess';
import http, { HttpPromise } from './http';

export default {
  register: (params: RequestRegistration): HttpPromise => http.post(`${Config.apiHost}/register/`, params),
  registerProcess: (params: RequestProcessRegistration): HttpPromise => http.post(`${Config.apiHost}/register/process/`, params),
  info: (): HttpPromise<InfoResponse> => http.get<InfoResponse>(`${Config.apiHost}/register/info/`),
  data: (): HttpPromise<DataResponse> => http.get<DataResponse>(`${Config.apiHost}/register/data/`),
};
